module.exports = __webpack_public_path__ + "img/top.8979c86c.png";